export default __webpack_public_path__ + "static/media/my_customer_voice_theme_logo.fbe6e9a1.png";